export const FINANCE_DOCS_EN = {
    'cell.image': 'An image',
    // ── #94: every problem before issue, by the rule issue refuses with ──
    'invoicing.problem.address': 'The buyer\'s national address is missing',
    'invoicing.problem.address.street': 'The buyer\'s address needs its street',
    'invoicing.problem.address.building_number': 'The buyer\'s address needs its building number, of 4 digits',
    'invoicing.problem.address.district': 'The buyer\'s address needs its district',
    'invoicing.problem.address.city': 'The buyer\'s address needs its city',
    'invoicing.problem.address.region': 'The buyer\'s address needs its region',
    'invoicing.problem.address.postcode': 'The buyer\'s address needs its postal code',
    'invoicing.problem.address.country': 'The buyer\'s address needs its country',
    'invoicing.problem.classification': 'A simplified invoice to a buyer with a VAT number needs the reason for the choice',
    'invoicing.problem.vat_number': 'A standard tax invoice needs the buyer\'s VAT number',
    'invoicing.problem.vat_number.format': 'The buyer\'s VAT number is 15 digits, starting and ending with 3 ({vat})',
    'invoicing.problem.vat_number.self': 'The buyer cannot be the seller: the buyer\'s VAT number is our own',
    'invoicing.problem.withholding.residency': 'Withholding applies to a non-resident party only',
    'invoicing.problem.issue_on': 'The issue date cannot be in the future',
    'invoicing.problem.journal_id': 'Choose the sales journal',
    'invoicing.problem.lines': 'An invoice is issued with at least one line',
    'invoicing.problem.account_id': 'Line {line} needs its account',
    'invoicing.problem.tax_code_id': 'Line {line} names a tax code that does not exist',
    'invoicing.problem.tax_code_id.none': 'Line {line} has no VAT category; the authority expects one on every line',
    'invoicing.problem.tax_code_id.validity': 'Line {line}: its tax code is not in force on the issue date',
    'invoicing.problem.tax_pack': 'The tax codes must be confirmed before anything is issued (line {line})',
    'invoicing.problem.exemption_reason': 'Line {line}: a zero-rated or exempt code needs its exemption reason',
    'invoicing.problem.seller': 'No e-invoicing seller is registered for this branch: the invoice is issued without a QR code or an e-document',
    'invoicing.problem.state': 'Already issued: nothing is left to check',
    'editor.invoice.resolved': 'Issued as',
    'editor.invoice.resolved.standard': 'Tax invoice',
    'editor.invoice.resolved.simplified': 'Simplified tax invoice',
    'editor.invoice.problems.errors': 'Not issued yet — {n} to fix first:',
    'editor.invoice.problems.warnings': 'Issue goes ahead, but note:',
    'editor.invoice.problems.held': 'Saved as a draft: {n} to fix before it is issued, listed below',
    // ── #94: what the authority made of it ──
    'screen.invoicing.documents.column.einvoice_outcome': 'ZATCA',
    'value.einvoice_outcome.not_sent': 'Not sent',
    'value.einvoice_outcome.pending': 'Waiting for the authority',
    'value.einvoice_outcome.cleared': 'Cleared',
    'value.einvoice_outcome.reported': 'Reported',
    'value.einvoice_outcome.accepted_with_warnings': 'Accepted with warnings',
    'value.einvoice_outcome.rejected': 'Rejected',
    'value.einvoice_outcome.unreachable': 'Did not reach the authority',
    'value.einvoice_next_step.credit_note': 'Not cleared, so it is not handed to the buyer: cancel it with a credit note, then issue a corrected invoice',
    'value.einvoice_next_step.fix_and_reissue': 'The buyer already holds it: fix what the authority named, then credit it and issue it again',
    'screen.einvoicing.document_edocument.col.outcome': 'ZATCA',
    'screen.einvoicing.document_edocument.col.warnings': 'The authority\'s warnings',
    'screen.einvoicing.document_edocument.col.next_step': 'What to do next',
    'screen.einvoicing.document_edocument.action.resubmit': 'Try again',
    'screen.einvoicing.document_rejected.alert': 'The authority refused this e-invoice. The invoice stays posted: its e-invoice card says what to do next.',
    // ── #84: the printed copy ──
    'screen.invoicing.documents.action.print': 'Print or save as PDF',
    // ── #83: the document's page ──
    'screen.invoicing.document_tax_rates.title': 'VAT by rate',
    'screen.invoicing.document_tax_rates.column.rate': 'Rate',
    'screen.invoicing.document_tax_rates.rate': 'VAT {rate:number}%',
    'screen.invoicing.document_tax_rates.column.taxable': 'Taxed amount',
    'screen.invoicing.document_tax_rates.column.tax': 'VAT',
    'screen.invoicing.document_tax_rates.column.lines': 'Lines',
    'screen.invoicing.document_tax_rates.empty': 'No lines yet.',
    'screen.invoicing.document_tax_rates.note': 'A rate shown as «—» is a line with no VAT category.',
    'screen.invoicing.document_tax_rates.sum': 'Total',
    'screen.einvoicing.document_edocument.col.qr': 'QR code',
    'screen.einvoicing.document_edocument.col.channel': 'Channel',
    'value.einvoice_channel.clearance': 'Clearance (standard, before it is handed over)',
    'value.einvoice_channel.reporting': 'Reporting (simplified, within 24 hours)',
    'value.einvoice_channel.not_required': 'Issue only (phase one): nothing is sent',
    // ── #90: files kept with a record ──
    'screen.accounting.attachments.title': 'Attachments',
    'screen.accounting.attachments.column.filename': 'File',
    'screen.accounting.attachments.column.note': 'Note',
    'screen.accounting.attachments.column.added_at': 'Added',
    'screen.accounting.attachments.column.size': 'Size',
    'screen.accounting.attachments.column.content_type': 'Type',
    'screen.accounting.attachments.column.previewable': 'Opens in the browser',
    'screen.accounting.attachments.action.attach': 'Attach a file',
    'screen.accounting.attachments.action.open': 'Open',
    'screen.accounting.attachments.action.withdraw': 'Withdraw',
    'screen.accounting.attachments.field.file': 'File',
    'screen.accounting.attachments.field.file.help': 'A PDF, an image, a spreadsheet or a Word file, up to 10 MB. It is kept in the files service; adding it changes nothing on the record.',
    'screen.accounting.attachments.field.note': 'Note',
    'screen.accounting.attachments.field.reason': 'Why',
    'screen.accounting.attachments.field.reason.help': 'The file is not deleted: it is kept with who withdrew it and why, and no longer listed.',
    'screen.accounting.attachments.empty': 'No file is kept with this record yet.',
    'screen.accounting.attachments.note': 'Files are kept in the files service. Adding one after issue does not change the record or its e-invoice.',
    'change.field.attachment.owner_kind': 'Kept with',
    'change.field.attachment.owner_id': 'Record',
    'change.field.attachment.media_file_id': 'File in the files service',
    'change.field.attachment.filename': 'File name',
    'change.field.attachment.content_type': 'File type',
    'change.field.attachment.size_bytes': 'Size',
    'change.field.attachment.note': 'Note',
    'change.field.attachment.added_by': 'Added by',
    'change.field.attachment.withdrawn_at': 'Withdrawn at',
    'change.field.attachment.withdrawn_by': 'Withdrawn by',
    'change.field.attachment.withdraw_reason': 'Why it was withdrawn',
    'accounting.attachment.file': 'Choose the file to attach',
    'accounting.attachment.type': 'This kind of file is not attached here: a PDF, an image, a spreadsheet or a Word file',
    'accounting.attachment.size': 'The file is larger than 10 MB',
    'accounting.attachment.reason': 'Say why the attachment is withdrawn',
    // ── the VAT return's boxes as the authority's form numbers them; values the logs show ──
    'screen.invoicing.vat_return.box.sales_standard': '1 · Standard rated sales',
    'screen.invoicing.vat_return.box.sales_zero': '3–4 · Zero-rated domestic sales and exports',
    'screen.invoicing.vat_return.box.sales_exempt': '5 · Exempt sales',
    'screen.invoicing.vat_return.box.sales_out_of_scope': 'Out-of-scope sales (not on the return)',
    'screen.invoicing.vat_return.box.purchases_standard': '7 · Standard rated domestic purchases',
    'screen.invoicing.vat_return.box.purchases_zero': '10 · Zero-rated purchases',
    'screen.invoicing.vat_return.box.purchases_exempt': '11 · Exempt purchases',
    'screen.invoicing.vat_return.box.purchases_out_of_scope': 'Out-of-scope purchases (not on the return)',
    'screen.invoicing.vat_return.box.purchases_nondeductible': 'Purchases with non-deductible VAT (outside box 7)',
    'screen.invoicing.vat_return.box.net_due': 'Net VAT due (or reclaimed)',
    'screen.accounting.deposits.column.number': 'Entry',
    'value.report_status.unreachable': 'Unreachable',
    'value.response_status.accepted': 'Accepted',
    'value.response_status.accepted_with_warnings': 'Accepted with warnings',
    'value.response_status.not_sent': 'Not sent',
};
export const FINANCE_DOCS_AR = {
    'cell.image': 'صورة',
    'invoicing.problem.address': 'العنوان الوطني للمشتري غير موجود',
    'invoicing.problem.address.street': 'عنوان المشتري ينقصه الشارع',
    'invoicing.problem.address.building_number': 'عنوان المشتري ينقصه رقم المبنى، من 4 أرقام',
    'invoicing.problem.address.district': 'عنوان المشتري ينقصه الحي',
    'invoicing.problem.address.city': 'عنوان المشتري تنقصه المدينة',
    'invoicing.problem.address.region': 'عنوان المشتري تنقصه المنطقة',
    'invoicing.problem.address.postcode': 'عنوان المشتري ينقصه الرمز البريدي',
    'invoicing.problem.address.country': 'عنوان المشتري تنقصه الدولة',
    'invoicing.problem.classification': 'الفاتورة المبسطة لمشترٍ له رقم ضريبي تحتاج سبب هذا الاختيار',
    'invoicing.problem.vat_number': 'الفاتورة الضريبية تحتاج الرقم الضريبي للمشتري',
    'invoicing.problem.vat_number.format': 'الرقم الضريبي للمشتري 15 رقماً يبدأ بـ3 وينتهي بـ3 ({vat})',
    'invoicing.problem.vat_number.self': 'لا يكون المشتري هو البائع: الرقم الضريبي للمشتري هو رقمنا',
    'invoicing.problem.withholding.residency': 'ضريبة الاستقطاع على المورّد غير المقيم فقط',
    'invoicing.problem.issue_on': 'تاريخ الإصدار لا يكون في المستقبل',
    'invoicing.problem.journal_id': 'اختر دفتر المبيعات',
    'invoicing.problem.lines': 'تصدر الفاتورة ببند واحد على الأقل',
    'invoicing.problem.account_id': 'البند {line} ينقصه الحساب',
    'invoicing.problem.tax_code_id': 'البند {line} يذكر رمز ضريبة غير موجود',
    'invoicing.problem.tax_code_id.none': 'البند {line} بلا فئة ضريبة، والهيئة تنتظر فئة على كل بند',
    'invoicing.problem.tax_code_id.validity': 'البند {line}: رمز ضريبته غير سارٍ في تاريخ الإصدار',
    'invoicing.problem.tax_pack': 'تُؤكَّد رموز الضريبة قبل إصدار أي شيء (البند {line})',
    'invoicing.problem.exemption_reason': 'البند {line}: الرمز الصفري أو المعفى يحتاج سبب الإعفاء',
    'invoicing.problem.seller': 'لا بيانات منشأة بائعة مسجّلة للفوترة الإلكترونية في هذا الفرع: تصدر الفاتورة بلا رمز QR ولا فاتورة إلكترونية',
    'invoicing.problem.state': 'صدرت من قبل: لم يبقَ ما يُفحص',
    'editor.invoice.resolved': 'تصدر بوصفها',
    'editor.invoice.resolved.standard': 'فاتورة ضريبية',
    'editor.invoice.resolved.simplified': 'فاتورة ضريبية مبسطة',
    'editor.invoice.problems.errors': 'لم تصدر بعد — {n} يُصلح أولاً:',
    'editor.invoice.problems.warnings': 'يمضي الإصدار، مع التنبّه إلى:',
    'editor.invoice.problems.held': 'حُفظت مسودةً: {n} يُصلح قبل إصدارها، مبيّن أدناه',
    'screen.invoicing.documents.column.einvoice_outcome': 'الهيئة',
    'value.einvoice_outcome.not_sent': 'لم تُرسل',
    'value.einvoice_outcome.pending': 'بانتظار الهيئة',
    'value.einvoice_outcome.cleared': 'اعتُمدت',
    'value.einvoice_outcome.reported': 'أُبلغت',
    'value.einvoice_outcome.accepted_with_warnings': 'مقبولة مع ملاحظات',
    'value.einvoice_outcome.rejected': 'مرفوضة',
    'value.einvoice_outcome.unreachable': 'لم تصل إلى الهيئة',
    'value.einvoice_next_step.credit_note': 'لم تُعتمد فلا تُسلَّم للمشتري: ألغِها بإشعار دائن ثم أصدر فاتورة مصحّحة',
    'value.einvoice_next_step.fix_and_reissue': 'المشتري يحملها الآن: أصلح ما ذكرته الهيئة، ثم أصدر إشعاراً دائناً وفاتورة جديدة',
    'screen.einvoicing.document_edocument.col.outcome': 'الهيئة',
    'screen.einvoicing.document_edocument.col.warnings': 'ملاحظات الهيئة',
    'screen.einvoicing.document_edocument.col.next_step': 'الخطوة التالية',
    'screen.einvoicing.document_edocument.action.resubmit': 'إعادة المحاولة',
    'screen.einvoicing.document_rejected.alert': 'رفضت الهيئة هذه الفاتورة الإلكترونية. تبقى الفاتورة مرحّلة، وبطاقة الفاتورة الإلكترونية تقول ما الخطوة التالية.',
    'screen.invoicing.documents.action.print': 'طباعة أو حفظ PDF',
    'screen.invoicing.document_tax_rates.title': 'الضريبة حسب النسبة',
    'screen.invoicing.document_tax_rates.column.rate': 'النسبة',
    'screen.invoicing.document_tax_rates.rate': 'ضريبة {rate:number}٪',
    'screen.invoicing.document_tax_rates.column.taxable': 'المبلغ الخاضع',
    'screen.invoicing.document_tax_rates.column.tax': 'الضريبة',
    'screen.invoicing.document_tax_rates.column.lines': 'البنود',
    'screen.invoicing.document_tax_rates.empty': 'لا بنود بعد.',
    'screen.invoicing.document_tax_rates.note': 'النسبة «—» بند بلا فئة ضريبة.',
    'screen.invoicing.document_tax_rates.sum': 'المجموع',
    'screen.einvoicing.document_edocument.col.qr': 'رمز QR',
    'screen.einvoicing.document_edocument.col.channel': 'المسار',
    'value.einvoice_channel.clearance': 'الاعتماد (التخليص): القياسية، قبل تسليمها',
    'value.einvoice_channel.reporting': 'الإبلاغ: المبسّطة، خلال 24 ساعة',
    'value.einvoice_channel.not_required': 'إصدار فقط (المرحلة الأولى): لا يُرسل شيء',
    'screen.accounting.attachments.title': 'المرفقات',
    'screen.accounting.attachments.column.filename': 'الملف',
    'screen.accounting.attachments.column.note': 'ملاحظة',
    'screen.accounting.attachments.column.added_at': 'أُضيف',
    'screen.accounting.attachments.column.size': 'الحجم',
    'screen.accounting.attachments.column.content_type': 'النوع',
    'screen.accounting.attachments.column.previewable': 'يُفتح في المتصفح',
    'screen.accounting.attachments.action.attach': 'إرفاق ملف',
    'screen.accounting.attachments.action.open': 'فتح',
    'screen.accounting.attachments.action.withdraw': 'سحب',
    'screen.accounting.attachments.field.file': 'الملف',
    'screen.accounting.attachments.field.file.help': 'ملف PDF أو صورة أو جدول أو ملف Word، حتى 10 ميغابايت. يُحفظ في خدمة الملفات، وإرفاقه لا يغيّر شيئاً في السجل.',
    'screen.accounting.attachments.field.note': 'ملاحظة',
    'screen.accounting.attachments.field.reason': 'السبب',
    'screen.accounting.attachments.field.reason.help': 'لا يُحذف الملف: يبقى محفوظاً مع من سحبه ولماذا، ولا يظهر في القائمة.',
    'screen.accounting.attachments.empty': 'لا ملف محفوظ مع هذا السجل بعد.',
    'screen.accounting.attachments.note': 'تُحفظ الملفات في خدمة الملفات. إرفاق ملف بعد الإصدار لا يغيّر السجل ولا فاتورته الإلكترونية.',
    'change.field.attachment.owner_kind': 'مرفق بـ',
    'change.field.attachment.owner_id': 'السجل',
    'change.field.attachment.media_file_id': 'الملف في خدمة الملفات',
    'change.field.attachment.filename': 'اسم الملف',
    'change.field.attachment.content_type': 'نوع الملف',
    'change.field.attachment.size_bytes': 'الحجم',
    'change.field.attachment.note': 'ملاحظة',
    'change.field.attachment.added_by': 'أضافه',
    'change.field.attachment.withdrawn_at': 'سُحب في',
    'change.field.attachment.withdrawn_by': 'سحبه',
    'change.field.attachment.withdraw_reason': 'سبب السحب',
    'accounting.attachment.file': 'اختر الملف المراد إرفاقه',
    'accounting.attachment.type': 'لا يُرفق هذا النوع هنا: ملف PDF أو صورة أو جدول أو ملف Word',
    'accounting.attachment.size': 'الملف أكبر من 10 ميغابايت',
    'accounting.attachment.reason': 'اذكر سبب سحب المرفق',
    // ── خانات الإقرار بأرقام نموذج الهيئة؛ قيم تعرضها السجلات ──
    'screen.invoicing.vat_return.box.sales_standard': '1 · المبيعات الخاضعة للنسبة الأساسية',
    'screen.invoicing.vat_return.box.sales_zero': '3 و4 · المبيعات المحلية الخاضعة للنسبة الصفرية والصادرات',
    'screen.invoicing.vat_return.box.sales_exempt': '5 · المبيعات المعفاة',
    'screen.invoicing.vat_return.box.sales_out_of_scope': 'مبيعات خارج نطاق الضريبة (لا تدخل الإقرار)',
    'screen.invoicing.vat_return.box.purchases_standard': '7 · المشتريات الخاضعة للنسبة الأساسية',
    'screen.invoicing.vat_return.box.purchases_zero': '10 · المشتريات الخاضعة للنسبة الصفرية',
    'screen.invoicing.vat_return.box.purchases_exempt': '11 · المشتريات المعفاة',
    'screen.invoicing.vat_return.box.purchases_out_of_scope': 'مشتريات خارج نطاق الضريبة (لا تدخل الإقرار)',
    'screen.invoicing.vat_return.box.purchases_nondeductible': 'مشتريات ضريبتها غير قابلة للخصم (خارج الخانة 7)',
    'screen.invoicing.vat_return.box.net_due': 'صافي الضريبة المستحقة (أو المستردّة)',
    'screen.accounting.deposits.column.number': 'القيد',
    'value.report_status.unreachable': 'تعذّر الوصول',
    'value.response_status.accepted': 'مقبول',
    'value.response_status.accepted_with_warnings': 'مقبول بملاحظات',
    'value.response_status.not_sent': 'لم يُرسل',
};
//# sourceMappingURL=i18n-finance-docs.js.map